export default __webpack_public_path__ + "static/media/karier_jakarta.636154be.jpeg";